import MicIcon from "@mui/icons-material/Mic";
import { Dialog, styled, Typography } from "@mui/material";

export const StyledVoiceVisualization = {
  Dialog: styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "rgb(70, 70, 70, 1)",
    },
  })),

  MicIcon: styled(MicIcon)(({ theme }) => ({
    marginTop: 20,
    width: 24,
    height: 24,
    color: theme.palette.primary.main,
  })),

  TranscriptTypography: styled(Typography)(({ theme }) => ({
    margin: 20,
  })),
};
